import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class ImportOrderService {

  constructor(private http: HttpClient,
    private occService: OccEndpointsService,) { }


  getApi(cartId) {
    return this.http.get(this.occService.buildUrl(`getimportorder?cartId=${cartId}`));
  }

  postApi(file, ordertpye, cartId) {
    return this.http.post(this.occService.buildUrl(`importorder?orderType=${ordertpye}&cartId=${cartId}`), file);
  }
  getOrderType(orderType, cartId) {
    return this.http.get(this.occService.buildUrl(`getordertype?orderType=${orderType}&cartId=${cartId}`))
  }
}
